/* global Office */

import React from 'react';
import ReactDOM from 'react-dom';
import bayonConfig from '@core/bayon.config';
import { initSentry } from '@lib/pj-commons-frontend';

import App from './core/App';
import { stringToBoolean } from './utils';

const sessionReplayEnabled = stringToBoolean(
  bayonConfig?.sentry?.sessionReplayEnabled ?? false
);

initSentry({
  release: 'pj-word-addin-frontend',
  environment: bayonConfig.sentry.environment,
  options: {
    replaysSessionSampleRate: sessionReplayEnabled ? 1 : 0,
    replaysOnErrorSampleRate: sessionReplayEnabled ? 1 : 0,
  },
});

let isOfficeInitialized = false;

const render = (Component) => {
  ReactDOM.render(
    <Component isOfficeInitialized={isOfficeInitialized} />,
    document.getElementById('container')
  );
};

Office.initialize = () => {
  isOfficeInitialized = true;
  render(App);
};
